import React, { useState, useEffect } from "react";
import { Card, Table, Tag } from "antd";
import axios from "axios";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";
import orgUsersQuery from "../queries/orgUsersQuery";

const MarketplaceOrgUsers = ({ orgId }) => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const fetchUsers = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const variables = {
        first: pageSize,
        skip: (page - 1) * pageSize,
        where: {
          marketplace_org_pointer: {
            have: {
              objectId: { equalTo: orgId },
            },
          },
        },
      };

      const response = await axios.post(
        graphqlUrl,
        {
          query: orgUsersQuery,
          variables,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const edges = response.data?.marketplace_users?.edges || [];
      const count = response.data?.marketplace_users?.count || 0;

      setUsers(edges.map((edge) => edge.node));
      setPagination((prev) => ({ ...prev, current: page, pageSize, total: count }));
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  const handleTableChange = (newPagination) => {
    fetchUsers(newPagination.current, newPagination.pageSize);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "objectId",
      key: "objectId",
    },
    {
      title: "Nome",
      key: "name",
      render: (_, record) => `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Telefono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Stato",
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active) => (
        <Tag color={is_active ? "green" : "red"}>
          {is_active ? "ATTIVO" : "DISATTIVO"}
        </Tag>
      ),
    },
    {
      title: "Data Creazione",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleDateString("it-IT"),
    },
  ];

  return (
    <Card title="Utenti Marketplace">
      <Table
        dataSource={users}
        columns={columns}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey="objectId"
      />
    </Card>
  );
};

export default MarketplaceOrgUsers;
